import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Admin } from '../../../admin/models/Admin';
import { AdminService } from '../../../admin/services/AdminService';
import { SessionService  } from '../../../admin/services/SessionService';
import { LocalStorageService  } from '../../../core/services/LocalStorageService';
import { Subscription }   from 'rxjs/Subscription';
import { AdminPassword } from '../../../admin/models/AdminPassword';
// import NgForm
import { NgForm } from '@angular/forms';
import { devEnv, testEnv, procEnv, stagingEnv, localEnv, demoEnv, bisHanoiEnv, bisHanoiDevEnv, bisHanoiStagingEnv, ishcmcEnv, aavnIshcmcEnv, primaryIshcmcEnv, secondaryIshcmcEnv, isspEnv, demoHelenEnv } from '../../../../config/config'

import * as $ from 'jquery';
@Component({
    selector: 'admin-header',
    template: require('./AdminHeaderComponent.html'),
    styles: [require('./AdminHeaderComponent.sass')]
})

export class AdminHeaderComponent implements OnInit{
    @Input() module: string;
    private headerName: string;
    private subscription: Subscription;
    private adminData: Admin;
    private sidebarStatus: boolean;
	private hostName: string;
    private errorMessage: string;
    // For change password
    private isShow: boolean = false;
    private isShowChangePassword: boolean = false;
    private oldPassword: string="";
    private newPassword: string="";
    private confirmPassword: string="";
    private isOPassWrong: boolean = false;
    private oPassCheck: string = '';
    //message
    private msgs:any = [];
    // For logout navigate

    constructor(
        private adminService: AdminService,
        private sessionService: SessionService,
        private router: Router,
    ) { }

    ngOnInit() {
        this.getSession();
        this.hostName = window.location.hostname;
        this.headerName = this.getHeaderName(this.module);

        this.subscription = this.adminService.adminDataChanged$.subscribe(
            admin => {
                this.onSessionChanged(admin);
            }
        );
        // Get Admin session
        this.adminData = this.adminService.getAdminSessionData();
    }

    ngOnDestroy() {
        // Destroy the subscription for session changes
        this.subscription.unsubscribe();
    } 

    private showDropDown(){
        this.isShow = !this.isShow;
    }

    //on click outside,close div 
    onClickOutside(event: Object) {
        if (event && event['value'] === true) {
            this.isShow = false;
        }
    }

    private changePassword(){
        this.isShowChangePassword = !this.isShowChangePassword;
    }

    private onSubmitChangePassword(myForm: NgForm){
        let adminPassword: AdminPassword = {
            role: this.adminData.role,
            username : this.adminData.name,
            password: {
                old: this.oldPassword,
                new: this.newPassword
            }
        }
        this.postPassword(adminPassword,myForm);
    }

    private onCloseChangePassword(myForm: NgForm){
        this.clearPass()
        myForm.resetForm();
    }

     /**
     * Post password to change admin ldap password
     * @param {adminPassword} - admin credential input
     * @return none
     */
    private postPassword(adminPassword: AdminPassword,myForm: NgForm) {
        this.sessionService.changeAdminPassword(adminPassword)
            .subscribe(
                result => {
                    this.isShowChangePassword = false;
                    this.clearPass();
                    //reset form state
                    myForm.resetForm();
                    this.msgs.push({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'Password has been updated'
                    });
                },
                err => {
                    this.oPassCheck = this.oldPassword;
                    if(err.status == 401){
                        this.isOPassWrong = true;
                        //focus old password
                        setTimeout(function(){ 
                            $('#opass').focus();
                         }, 10);
                    }
                    else{
                        this.msgs.push({
                            severity: 'error',
                            summary: 'Error',
                            detail: 'Something went wrong. Please try again'
                        });
                    }
                }
            );
    }

    clearPass(){
        this.oldPassword = '';
        this.newPassword = '';
        this.confirmPassword = '';
    }

    private onSessionChanged(admin: Admin) {
        //TO DO: update menu content when session changed
        this.adminData = admin;
        this.sidebarStatus = this.getSidebarStatus();
    }

    private getSession() : void{
        this.sessionService.getSession()
            .subscribe(
                admin => {
                    this.adminData = admin
                    this.sidebarStatus = this.getSidebarStatus();
                },
                error => {
                }
            );
    }
    
    toHomePage() {
        // Redirect to desired URL                    
        if(Object.values(devEnv).indexOf(this.hostName) !== -1){
            return window.location.href = `http://${devEnv.services}`;
        }
        else if(Object.values(demoEnv).indexOf(this.hostName) !== -1){
            return window.location.href = `http://${demoEnv.services}`;
        }
        else if(Object.values(bisHanoiEnv).indexOf(this.hostName) !== -1){
            return window.location.href = `http://${bisHanoiEnv.services}`;
        }
        else if(Object.values(bisHanoiDevEnv).indexOf(this.hostName) !== -1){
            return window.location.href = `http://${bisHanoiDevEnv.services}`;
        }
        else if(Object.values(bisHanoiStagingEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${bisHanoiStagingEnv.services}`;
		}
		else if(Object.values(ishcmcEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${ishcmcEnv.services}`;
		}
		else if(Object.values(aavnIshcmcEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${aavnIshcmcEnv.services}`;
		}
		else if(Object.values(primaryIshcmcEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${primaryIshcmcEnv.services}`;
		}
		else if(Object.values(secondaryIshcmcEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${secondaryIshcmcEnv.services}`;
		}
		else if(Object.values(isspEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${isspEnv.services}`;
		}
        else if(Object.values(demoHelenEnv).indexOf(this.hostName) !== -1){
			return window.location.href = `http://${demoHelenEnv.services}`;
		}
        else if(Object.values(testEnv).indexOf(this.hostName) !== -1){
            return window.location.href = `http://${testEnv.services}`;
        }
        else if(Object.values(stagingEnv).indexOf(this.hostName) !== -1){
            return window.location.href = `http://${stagingEnv.services}`;
        }
        else if(Object.values(procEnv).indexOf(this.hostName) !== -1){
            return window.location.href = `http://${procEnv.services}`;
        }
        else{
            return window.location.href = `http://${localEnv.services}`;
        }
    }

    // Detect sidebar vibibility
    private getSidebarStatus() {
        return !this.adminData ? false : true;
    }
    
    private getHeaderName(moduleName: string): string {
        let headerName = "";
        switch(this.module) {
            case "camp":
                headerName = "Camp Programmes Management";
                break;
            case "asa":
                headerName = "After School Activities Management";
                break;
            case "bus":
                headerName = "Bus Programmes Management";
            case "reen":
                headerName = "";
            default:
                break;
        }
        
        return headerName;
    }

    // Log our function
    private deleteSession() {
        // console.log(this.hostName)
        this.module = 'auth';
        this.sessionService.deleteAdminSession()
            .subscribe(
                complete => {
                    // Clear user session
                    this.adminService.clearAdminSessionData();
                    // Fire user session data changed event
                    this.adminService.adminDataChanged(null);
                    // Redirect to desired URL
                    if(Object.values(devEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${devEnv.auth}/login`;
                    }
                    else if(Object.values(demoEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${demoEnv.auth}/login`;
                    }
                    else if(Object.values(bisHanoiEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${bisHanoiEnv.auth}/login`;
                    }
                    else if(Object.values(bisHanoiDevEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${bisHanoiDevEnv.auth}/login`;
                    }
                    else if(Object.values(bisHanoiStagingEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${bisHanoiStagingEnv.auth}/login`;
                    }
                    else if(Object.values(ishcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${ishcmcEnv.auth}/login`;
                    }
                    else if(Object.values(aavnIshcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${aavnIshcmcEnv.auth}/login`;
                    }
                    else if(Object.values(primaryIshcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${primaryIshcmcEnv.auth}/login`;
                    }
                    else if(Object.values(secondaryIshcmcEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${secondaryIshcmcEnv.auth}/login`;
                    }
                    else if(Object.values(isspEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${isspEnv.auth}/login`;
                    }
                    else if(Object.values(demoHelenEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${demoHelenEnv.auth}/login`;
                    }
                    else if(Object.values(testEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `http://${testEnv.auth}/login`;
                    }
                    else if(Object.values(stagingEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `https://${stagingEnv.auth}/login`;
                    }
                    else if(Object.values(procEnv).indexOf(this.hostName) !== -1){
                        return window.location.href = `https://${procEnv.auth}/login`;
                    }
                    else{
                        return window.location.href = `http://${localEnv.auth}/login`;
                    }
                },
                error    => this.errorMessage = <any> error
            );
    }
}



// WEBPACK FOOTER //
// ./src/common/modules/core/components/admin-header/AdminHeaderComponent.ts